/**
 * Copyright (c) Siemens 2016 - 2026
 * SPDX-License-Identifier: MIT
 */
/** */
export const environment = {
  mfeBaseUrl: './mfe',
  mfeEsmBaseUrl: './mfe-esm',
  webComponentsBaseUrl: './webcomponents',
  useModuleFederation: true
};
